import { MemberCapability } from '@/helpers/member-capability';
import { Litigation } from '@/Litigation/litigation.entity';

export enum MemberRole {
    ADMIN = 'admin',
    SUPERVISOR = 'supervisor',
    USER = 'user',
    EXPERT = 'expert',
}

export type Member = {
    memberId?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    role?: MemberRole;
    timeZone?: string;
    litigations?: Array<Litigation>;
    isEnabled?: boolean;
    capabilities?: MemberCapability[];
    password?: string;
    passwordResetRequired?: boolean;
};
